import { RiPoliceCarLine } from "react-icons/ri";
import TitleStripe from "../TitleStripe";
import NoOcurrence from "./NoOcurrence";
import {
  MdOutlineCarCrash,
  MdOutlineCarRental,
  MdOutlineCarRepair,
  MdOutlineLocalTaxi,
  MdOutlineStore,
} from "react-icons/md";
import { LiaExchangeAltSolid } from "react-icons/lia";
import { LuChurch } from "react-icons/lu";
import { IoCarOutline, IoCarSportSharp } from "react-icons/io5";
import { PiBank, PiCarSimpleFill, PiMoneyThin } from "react-icons/pi";
import { FaCarRear } from "react-icons/fa6";
import { AiOutlineAudit } from "react-icons/ai";
import { FaCarCrash, FaRegWindowClose } from "react-icons/fa";
import { GiRobber, GiTowTruck } from "react-icons/gi";

const descriptions = {
  1: {
    descricao:
      "Trata-se de uma transferência de propriedade de um veículo para uma Cia de Seguros.",
    relevancia:
      "Indica que o ex proprietário do veículo foi indenizado integralmente em 99% dos casos.",
    componente: <LiaExchangeAltSolid fontSize={30} />,
  },
  2: {
    descricao:
      "Trata-se de veículos que pertencem ou pertenceram a frota própria ou locada que foram utilizados por organismos de segurança pública.",
    relevancia:
      "Veículos exigidos ao extremo em perseguições e possuem quilometragem altíssima.",
    componente: <RiPoliceCarLine fontSize={30} />,
  },
  3: {
    descricao:
      "Veículos que pertencem ou pertenceram à frota de empresa de locação de veículos.",
    relevancia:
      "Condutores trocados frequentemente, desgaste prematuro de peças e risco de adulteração.",
    componente: <MdOutlineCarRental fontSize={30} />,
  },
  4: {
    descricao:
      "Veículos adquiridos com isenção substancial de impostos (cerca de 50% de desconto).",
    relevancia:
      "Vida útil abreviada, desgaste prematuro e risco de adulteração ao serem revendidos.",
    componente: <MdOutlineLocalTaxi fontSize={30} />,
  },
  5: {
    descricao:
      "Veículos de frota de entidades religiosas, geralmente adquiridos por doações.",
    relevancia:
      "Risco jurídico crescente com processos solicitando devolução de bens doados.",
    componente: <LuChurch fontSize={30} />,
  },
  6: {
    descricao: "Veículos de frota pública utilizados em órgãos governamentais.",
    relevancia:
      "Condutores trocados frequentemente, desgaste prematuro e risco de adulteração.",
    componente: <IoCarOutline fontSize={30} />,
  },
  7: {
    descricao:
      "Veículos usados por empresas de segurança privada como escolta e monitoramento.",
    relevancia: "Exigência operacional intensa e quilometragem altíssima.",
    componente: <IoCarSportSharp fontSize={30} />,
  },
  9: {
    descricao: "Veículos que de fato operaram como táxi.",
    relevancia:
      "Desgaste prematuro e risco de adulteração ao serem revendidos.",
    componente: <MdOutlineLocalTaxi fontSize={30} />,
  },
  11: {
    descricao: "Veículos que operaram em frota de empresas.",
    relevancia:
      "Vida útil abreviada e risco de adulteração ao serem revendidos.",
    componente: <FaCarRear fontSize={30} />,
  },
  12: {
    descricao: "Veículos que foram leiloados.",
    relevancia: "Passaram por processos formais de leilão.",
    componente: <AiOutlineAudit fontSize={30} />,
  },
  13: {
    descricao:
      "Veículos que não foram aprovados na emissão de apólice de seguro online.",
    componente: <FaRegWindowClose fontSize={30} />,
    relevancia:
      "Exigem vistoria técnica aprofundada, possível envolvimento em sinistros.",
  },
  14: {
    descricao:
      "Veículos envolvidos em acidentes e vendidos diretamente por seguradoras.",
    relevancia: "Não passaram por leilão; adquiridos diretamente.",
    componente: <MdOutlineStore fontSize={30} />,
  },
  15: {
    descricao:
      "Veículo transferido para banco ou financeira por inadimplência.",
    relevancia: "Indica retomada do veículo por falta de pagamento.",
    componente: <PiBank fontSize={30} />,
  },
  17: {
    descricao: "Veículos que se envolveram em acidentes de trânsito.",
    relevancia: "Registro de colisões e danos associados.",
    componente: <FaCarCrash fontSize={30} />,
  },
  18: {
    descricao: "Veículos indenizados integralmente por Cia de Seguros.",
    relevancia: "Indenização total por parte da seguradora.",
    componente: <PiMoneyThin fontSize={30} />,
  },
  19: {
    descricao: "Veículos que sofreram diversos tipos de avarias e danos.",
    relevancia: "Histórico de danos estruturais ou funcionais.",
    componente: <MdOutlineCarRepair fontSize={30} />,
  },
  21: {
    descricao:
      "Veículos envolvidos em ocorrência policial com suspeita de clonagem.",
    relevancia: "Possível tentativa de fraude (dublê).",
    componente: <MdOutlineCarCrash fontSize={30} />,
  },
  22: {
    descricao:
      "Relatos de motoristas de plataforma sobre o recolhimento do veículo.",
    relevancia:
      "Comentário de avarias estruturais feitas no momento do embarque.",
    componente: <GiTowTruck fontSize={30} />,
  },
  23: {
    descricao: "Veículos utilizados diretamente na prática de crimes.",
    relevancia: "Registro de envolvimento criminal formalizado.",
    componente: <GiRobber fontSize={30} />,
  },
};

const Checklist = ({ data }) => {
  return (
    <div className="mt-3">
      <TitleStripe>Checklist</TitleStripe>
      {data?.checklist?.ocorrencias?.map((item, index) => (
        <div className="mt-5" key={index}>
          <TitleStripe
            className={`${item.status == 1 ? "bg-red-200" : " bg-green-200"}`}
          >
            {item.produto}
          </TitleStripe>
          <div className="flex gap-3 text-sm mt-3 ">
            <div
              className={`flex items-center justify-center rounded-md shadow-sm w-16 h-16 min-w-16 ${
                item.status == 1 ? "bg-red-200" : " bg-green-200"
              }`}
            >
              {descriptions?.[item.id]?.componente}
            </div>
            <div className="flex flex-col gap-2">
              <div>
                <span className="font-semibold">Descrição: </span>
                {descriptions?.[item.id]?.descricao || "Sem informação"}
              </div>
              <div>
                <span className="font-semibold">Relevância: </span>
                {descriptions?.[item.id]?.relevancia || "Sem informação"}
              </div>
            </div>
          </div>
          {item.status == 2 ? (
            <NoOcurrence />
          ) : (
            <div>
              <div className="font-semibold underline text-red-700 mt-3">
                Ocorrências:
              </div>
              {item?.resposta?.map((resp, indexp) => (
                <div
                  key={indexp}
                  className={`grid grid-cols-2 gap-2 mt-3 text-sm ${
                    item?.resposta?.length > 1
                      ? "border-b border-gray-200 pb-3"
                      : ""
                  }`}
                >
                  {resp.instituicao && (
                    <div>
                      <span className="font-semibold">Instituição:</span>{" "}
                      {resp.instituicao}
                    </div>
                  )}

                  {resp.cnpj && (
                    <div>
                      <span className="font-semibold">CNPJ:</span> {resp.cnpj}
                    </div>
                  )}

                  {resp.ano_informacao && (
                    <div>
                      <span className="font-semibold">Ano:</span>{" "}
                      {resp.ano_informacao}
                    </div>
                  )}

                  {resp.resposta && (
                    <div>
                      <span className="font-semibold">Resposta:</span>{" "}
                      {resp.resposta}
                    </div>
                  )}

                  {resp.cidade && (
                    <div>
                      <span className="font-semibold">Cidade:</span>{" "}
                      {resp.cidade}
                    </div>
                  )}

                  {resp.uf && (
                    <div>
                      <span className="font-semibold">UF:</span> {resp.uf}
                    </div>
                  )}

                  {resp.parecer && (
                    <div>
                      <span className="font-semibold">Parecer:</span>{" "}
                      {resp.parecer}
                    </div>
                  )}

                  {resp.classificacao && (
                    <div>
                      <span className="font-semibold">Classificação:</span>{" "}
                      {resp.classificacao}
                    </div>
                  )}

                  {resp.tipo_dano && (
                    <div>
                      <span className="font-semibold">Tipo de dano:</span>{" "}
                      {resp.tipo_dano}
                    </div>
                  )}

                  {resp.tipo_seguro && (
                    <div>
                      <span className="font-semibold">Tipo de seguro:</span>{" "}
                      {resp.tipo_seguro}
                    </div>
                  )}

                  {resp.tipo_idenizacao && (
                    <div>
                      <span className="font-semibold">
                        Tipo de indenização:
                      </span>{" "}
                      {resp.tipo_idenizacao}
                    </div>
                  )}

                  {resp.encaminhado_para_leilao && (
                    <div>
                      <span className="font-semibold">
                        Encaminhado para leilão:
                      </span>{" "}
                      {resp.encaminhado_para_leilao}
                    </div>
                  )}

                  {resp.motivo && (
                    <div>
                      <span className="font-semibold">Motivo:</span>{" "}
                      {resp.motivo}
                    </div>
                  )}

                  {resp.local_fatos && (
                    <div>
                      <span className="font-semibold">Local dos fatos:</span>{" "}
                      {resp.local_fatos}
                    </div>
                  )}

                  {resp.ano_fatos && (
                    <div>
                      <span className="font-semibold">Ano dos fatos:</span>{" "}
                      {resp.ano_fatos}
                    </div>
                  )}

                  {resp.tipo_crime && (
                    <div>
                      <span className="font-semibold">Tipo do crime:</span>{" "}
                      {resp.tipo_crime}
                    </div>
                  )}

                  {resp.comentario_condutor_plataforma && (
                    <div>
                      <span className="font-semibold">
                        Comentário do condutor:
                      </span>{" "}
                      {resp.comentario_condutor_plataforma}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Checklist;
